/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Action } from '@ngrx/store';
import { PreviewEnvironment } from 'app/shared-data/models';
import { TenantDetails } from 'app/page-modules/tenant-management/models';

// -------------------------------------------------------------------------
// Tenant added
export const TENANT_ADDED = '[Shared Data] Tenant Added';

// -------------------------------------------------------------------------
// Load tenant details for all tenants
export const LOAD_ALL_TENANT_DETAILS = '[Shared Data] Load All Tenant Details';
export const LOAD_ALL_TENANT_DETAILS_SUCCESS = '[Shared Data] Load All Tenant Details Success';
export const LOAD_ALL_TENANT_DETAILS_ERROR = '[Shared Data] Load All Tenant Details Error';

// -------------------------------------------------------------------------
// Load Preview Environments
export const LOAD_PREVIEW_ENVIRONMENTS = '[Shared Data] Load Preview Environments';
export const LOAD_PREVIEW_ENVIRONMENTS_SUCCESS = '[Shared Data] Load Preview Environments Success';
export const LOAD_PREVIEW_ENVIRONMENTS_ERROR = '[Shared Data] Load Preview Environments Error';

// -------------------------------------------------------------------------
// Tenant added
export class TenantAdded implements Action {
  readonly type = TENANT_ADDED;

  constructor(public tenantDetails: TenantDetails) {}
}

// -------------------------------------------------------------------------
// Load All Tenant details
export class LoadAllTenantDetails implements Action {
  readonly type = LOAD_ALL_TENANT_DETAILS;
}

export class LoadAllTenantDetailsSuccess implements Action {
  readonly type = LOAD_ALL_TENANT_DETAILS_SUCCESS;

  constructor(public tenantDetails: TenantDetails[]) {}
}

export class LoadAllTenantDetailsError implements Action {
  readonly type = LOAD_ALL_TENANT_DETAILS_ERROR;

  constructor(public errorMessage: string) {}
}

// -------------------------------------------------------------------------
// Load Preview Environments
export class LoadPreviewEnvironments implements Action {
  readonly type = LOAD_PREVIEW_ENVIRONMENTS;
}

export class LoadPreviewEnvironmentsSuccess implements Action {
  readonly type = LOAD_PREVIEW_ENVIRONMENTS_SUCCESS;

  constructor(public previewEnvironments: PreviewEnvironment[]) {}
}

export class LoadPreviewEnvironmentsError implements Action {
  readonly type = LOAD_PREVIEW_ENVIRONMENTS_ERROR;

  constructor(public errorMessage: string) {}
}

// -------------------------------------------------------------------------
export type All =
  | TenantAdded
  | LoadAllTenantDetails
  | LoadAllTenantDetailsSuccess
  | LoadAllTenantDetailsError
  | LoadPreviewEnvironments
  | LoadPreviewEnvironmentsSuccess
  | LoadPreviewEnvironmentsError;
